import { useCallback } from 'react'
import styles from './index.module.scss'
import RequirementForm from '@view/compoents/RequirementForm'
import { useNavigate } from 'react-router-dom'

function Requirement () {
    const navigate = useNavigate()
    const handleSubmitOk = useCallback(() => {
        navigate("/home/homemain/dashboard#pending")
    }, [])

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden"
            }}
        >
            <RequirementForm onSubmitOk={handleSubmitOk} />
        </div>
    )
}

export default Requirement